import React from 'react';

const WebsiteGraphModal = ({
    isOpen,
    onClose,
    websiteGraph
}) => {
    if (!isOpen) {
        return null;
    }

    if (!websiteGraph) {
        return null;
    }

    // Handle base64 encoded PNG
    const imageSrc = websiteGraph.startsWith('data:image') 
        ? websiteGraph 
        : `data:image/png;base64,${websiteGraph}`;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(7, 7, 10, 0.92)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10000,
                padding: '24px'
            }}
            onClick={onClose}
        >
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '1400px',
                    maxHeight: '90vh',
                    backgroundColor: '#121212',
                    borderRadius: '10px',
                    boxShadow: '0 18px 60px rgba(0, 0, 0, 0.55)',
                    border: '1px solid rgba(100, 181, 246, 0.35)',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '14px',
                        right: '14px',
                        backgroundColor: 'rgba(220, 53, 69, 0.92)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: '42px',
                        height: '42px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        boxShadow: '0 8px 20px rgba(220, 53, 69, 0.45)',
                        transition: 'transform 0.2s ease, background-color 0.2s ease',
                        zIndex: 1
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = 'rgba(207, 46, 60, 0.95)';
                        e.target.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'rgba(220, 53, 69, 0.92)';
                        e.target.style.transform = 'scale(1)';
                    }}
                >
                    ×
                </button>
                <div
                    style={{
                        flex: 1,
                        overflow: 'auto',
                        backgroundColor: '#0c0c0c',
                        padding: '24px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <div style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                        <h3
                            style={{
                                margin: '0 0 24px 0',
                                color: '#e0e0e0',
                                fontWeight: '600'
                            }}
                        >
                            Website Graph
                        </h3>
                        <img
                            src={imageSrc}
                            alt="Website Graph"
                            style={{
                                maxWidth: '100%',
                                height: 'auto',
                                borderRadius: '8px',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WebsiteGraphModal;






